export const PHONE_NUMBER = '(844) 493-6249';
